import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import "normalize.css/normalize.css";
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

